/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListOrganicTrafficEvaluationsOptions,
  ListOrganicTrafficEvaluationsStatus200,
  ListOrganicTrafficEvaluationsStatus400,
  ListOrganicTrafficEvaluationsStatus403,
  ListOrganicTrafficEvaluationsStatus500,
} from '../types/ListOrganicTrafficEvaluations'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listOrganicTrafficEvaluations } from '../clients/listOrganicTrafficEvaluations'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listOrganicTrafficEvaluationsQueryKey = ({
  query,
}: Omit<ListOrganicTrafficEvaluationsOptions, 'headers'> = {}) =>
  [{ url: '/v1/bots/organic-traffic/evaluations' }, ...(query ? [query] : [])] as const

type ListOrganicTrafficEvaluationsQueryKey = ReturnType<
  typeof listOrganicTrafficEvaluationsQueryKey
>

export function listOrganicTrafficEvaluationsQueryOptions(
  { query }: ListOrganicTrafficEvaluationsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listOrganicTrafficEvaluationsQueryKey({ query })
  return queryOptions<
    ListOrganicTrafficEvaluationsStatus200,
    ResponseErrorConfig<
      | ListOrganicTrafficEvaluationsStatus400
      | ListOrganicTrafficEvaluationsStatus403
      | ListOrganicTrafficEvaluationsStatus500
    >,
    ListOrganicTrafficEvaluationsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listOrganicTrafficEvaluations({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Admin only. Every scoring tick is recorded, including the ones that left the order book's mode alone, so that the mode a book sat in can be explained by the figures behind it. Newest first. Every filter is optional and narrows the set.
 * @summary List organic activity score evaluations
 * {@link /v1/bots/organic-traffic/evaluations}
 */
export function useListOrganicTrafficEvaluations<
  TData = ListOrganicTrafficEvaluationsStatus200,
  TQueryData = ListOrganicTrafficEvaluationsStatus200,
  TQueryKey extends QueryKey = ListOrganicTrafficEvaluationsQueryKey,
>(
  {
    query,
  }: {
    query?:
      | ListOrganicTrafficEvaluationsOptions['query']
      | (() => ListOrganicTrafficEvaluationsOptions['query'])
  } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListOrganicTrafficEvaluationsStatus200,
        ResponseErrorConfig<
          | ListOrganicTrafficEvaluationsStatus400
          | ListOrganicTrafficEvaluationsStatus403
          | ListOrganicTrafficEvaluationsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey =
    resolvedOptions?.queryKey ?? listOrganicTrafficEvaluationsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listOrganicTrafficEvaluationsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | ListOrganicTrafficEvaluationsStatus400
      | ListOrganicTrafficEvaluationsStatus403
      | ListOrganicTrafficEvaluationsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
